import React from 'react';
import PropTypes from 'prop-types';
import { shapes } from '@greenville/framework';
import { injectIntl, intlShape } from 'react-intl';
import { CircularProgress, Box, Typography } from '@mui/material';
import { inject, observer } from 'mobx-react';
import { getContainerStyles, getCircularProgressStyles, labelStyles } from './CustomLoaderStyles';

// CustomLoader Component
const CustomLoader = ({ size, color, customColor, thickness, label, centered, zIndex, language, intl }) => {
  const loadingLabel = label || intl.formatMessage(language.getText('common.LOADING'));

  return (
    <Box sx={getContainerStyles(centered, zIndex)}>
      <CircularProgress
        size={size}
        color={customColor ? 'inherit' : color}
        thickness={thickness}
        sx={getCircularProgressStyles(customColor)}
      />
      {label && (
        <Typography variant="h6" sx={labelStyles}>
          {loadingLabel}
        </Typography>
      )}
    </Box>
  );
};

// Prop type validation using PropTypes
CustomLoader.propTypes = {
  size: PropTypes.number,
  color: PropTypes.oneOf(['primary', 'secondary', 'inherit', 'error', 'success', 'info', 'warning', 'default']),
  customColor: PropTypes.string,
  thickness: PropTypes.number,
  label: PropTypes.string,
  centered: PropTypes.bool,
  zIndex: PropTypes.number,
  language: shapes.language.isRequired,
  intl: intlShape.isRequired
};

CustomLoader.defaultProps = {
  size: 40,
  color: 'primary',
  customColor: null,
  thickness: 3,
  label: null,
  centered: true,
  zIndex: null
};

export default injectIntl(inject('language')(observer(CustomLoader)));
